import type { Topology } from "topojson-specification";

export default {
  type: "Topology",
  arcs: [
    [
      [12813, 17645],
      [39, -190],
      [104, -265],
      [72, -114],
      [63, -129],
      [66, -101],
      [134, -162],
      [143, -138],
      [69, -56],
      [180, -122],
      [5, -39],
      [55, -79],
      [103, -92],
      [16, -53],
      [185, -120],
      [135, -57],
      [41, -6],
      [11, -112],
      [-10, -49],
      [36, -45],
      [73, -40],
    ],
    [
      [14333, 15676],
      [-30, -66],
      [7, -56],
      [-68, -35],
      [-103, -135],
      [-8, -73],
      [-88, -64],
      [-27, -86],
      [-49, -77],
      [-35, -10],
      [-31, -60],
      [-77, -73],
      [-45, 38],
      [-32, 145],
      [-121, 101],
      [-61, -24],
      [-31, 61],
      [-39, -3],
      [-31, 34],
      [-102, -81],
      [-17, -50],
      [-90, -27],
      [-33, -36],
      [31, -42],
      [10, -71],
      [55, -31],
      [-14, -45],
      [-62, -2],
      [-76, -24],
      [-81, 0],
      [-88, -131],
      [-44, 27],
      [-67, 5],
      [-27, -18],
    ],
    [
      [12859, 14767],
      [-37, 70],
      [-169, 56],
      [-59, 5],
      [-72, 42],
      [-1, 31],
      [-57, 57],
      [-41, -14],
      [-54, 47],
      [-42, -17],
      [-12, -51],
      [-80, -39],
      [-25, -29],
      [-88, 44],
      [-31, 69],
      [-71, 18],
      [-14, 27],
      [-85, 40],
      [-28, -42],
      [-44, 32],
      [-12, 86],
      [43, 83],
      [-49, 52],
      [-33, 0],
      [-26, 46],
      [-65, 13],
      [-95, 74],
      [-58, 12],
      [-104, 69],
      [-61, 25],
      [-7, -39],
      [-82, 16],
      [-49, 80],
      [-14, 60],
      [32, 105],
      [40, 9],
      [47, 51],
      [1, 80],
      [66, -3],
      [80, -62],
      [24, 20],
      [115, -75],
      [47, 29],
      [52, -3],
      [31, 54],
      [79, 45],
      [-63, 67],
      [-21, 52],
      [-49, 6],
      [-111, 131],
      [-4, 77],
      [-129, 89],
      [63, 58],
      [0, 46],
      [-60, 33],
      [-68, 71],
      [66, 44],
      [31, 56],
      [11, 64],
      [-36, 36],
      [60, 142],
      [123, -10],
      [53, -30],
      [63, 22],
      [93, 2],
      [23, 24],
      [2, 74],
      [24, 50],
      [-68, 17],
      [-35, 45],
      [13, 62],
      [-24, 16],
    ],
    [
      [11808, 17184],
      [80, -34],
      [68, 46],
      [43, 65],
      [65, 0],
      [27, 32],
      [-3, 57],
      [47, 58],
      [9, 51],
      [65, -39],
      [87, 36],
      [26, -29],
      [49, 9],
      [63, 37],
      [41, 78],
      [101, 13],
      [64, 40],
      [173, 41],
    ],
    [
      [18005, 11690],
      [-32, 12],
      [-69, 72],
      [-29, 69],
      [-100, 14],
      [-29, 32],
      [31, 54],
      [-37, 48],
      [-18, 62],
      [32, 125],
      [-25, 72],
      [28, 107],
      [-51, 58],
      [50, 28],
      [-162, 95],
      [-44, -4],
      [-56, 28],
      [-69, -25],
      [3, -67],
      [-75, 79],
      [-29, -51],
      [-86, -76],
      [-53, 6],
      [-35, 69],
      [-59, 37],
      [-54, 75],
      [-104, 93],
      [-46, 78],
      [-13, 75],
      [-37, 74],
      [-70, 27],
      [-43, -25],
      [-30, -45],
      [-48, 50],
      [-206, 91],
      [56, 33],
      [41, 62],
      [-7, 61],
      [18, 36],
      [-54, 48],
      [-55, 84],
      [-40, 39],
      [-57, 1],
      [-74, 65],
      [-128, -65],
      [-13, -46],
      [-55, -20],
      [-26, 33],
      [-125, -26],
      [-113, 31],
      [-94, -24],
      [-37, -80],
    ],
    [
      [15677, 13259],
      [-170, 53],
      [-88, 69],
      [-51, -53],
      [-93, 46],
      [-29, -26],
      [-54, 32],
      [-56, 80],
      [-43, 21],
      [-3, 45],
      [32, 41],
      [53, 30],
      [-21, 88],
      [53, 36],
      [-45, 50],
      [-60, 11],
      [-26, 27],
      [-90, -9],
      [-37, 65],
      [-51, 43],
      [-49, 11],
      [-24, 94],
      [40, 38],
      [31, 109],
      [-41, -2],
      [-76, 48],
      [-15, 57],
      [-29, 23],
    ],
    [
      [14735, 14286],
      [-72, 78],
      [-46, 11],
      [-4, 64],
      [22, 100],
      [-29, 64],
      [46, 64],
      [55, -41],
      [55, -17],
      [45, 80],
      [92, 39],
      [28, 52],
      [64, 30],
      [-56, 34],
      [-32, 50],
      [-10, 59],
      [31, 56],
      [3, 60],
      [-23, 76],
      [62, 78],
      [-4, 110],
    ],
    [
      [14962, 15333],
      [155, -20],
      [131, 3],
      [78, -9],
      [39, -33],
      [113, -2],
      [135, 19],
      [205, 45],
      [91, -30],
      [144, 4],
      [304, 41],
      [142, 40],
      [129, -23],
      [64, -63],
      [34, -1],
      [46, -64],
      [46, -122],
      [8, -83],
      [-13, -64],
      [-81, -77],
      [-37, -8],
      [-101, -109],
      [-56, -39],
      [-153, -78],
      [-80, -67],
      [-14, -70],
      [12, -120],
      [46, -104],
      [69, -89],
      [58, -45],
      [185, -90],
      [107, -67],
      [90, -35],
      [58, -53],
      [169, -58],
      [97, -58],
      [33, -6],
      [60, -53],
      [148, -58],
      [122, -81],
      [201, -74],
      [106, -28],
      [23, -28],
      [98, -41],
      [139, -45],
      [59, -35],
      [148, -38],
      [182, -110],
      [48, -14],
      [54, -68],
      [53, -18],
      [119, -88],
      [52, -63],
      [25, -53],
      [71, -34],
      [42, -52],
      [77, -52],
      [24, -39],
      [143, -79],
      [240, -82],
      [83, -48],
      [14, -26],
      [172, -106],
      [88, -19],
      [83, 8],
      [61, -99],
      [37, 9],
      [43, -70],
      [47, -49],
      [-19, -71],
      [72, -75],
      [5, -25],
      [66, -46],
      [21, -35],
      [130, -56],
      [88, -83],
      [145, -185],
      [29, -8],
      [89, -119],
      [40, -22],
      [72, -173],
      [-1, -69],
      [49, -92],
      [44, -47],
      [6, -63],
      [-63, -70],
      [-12, -71],
      [-76, -61],
      [-6, -54],
      [-28, -21],
      [-22, -72],
      [-15, -118],
      [9, -55],
      [-18, -104],
      [4, -64],
      [-40, -61],
      [-62, 5],
      [-46, 52],
      [-88, 46],
      [-83, 4],
      [-113, 61],
      [-24, 35],
      [-99, 68],
      [-53, 55],
      [-60, 101],
      [-6, 56],
      [22, 49],
      [-7, 43],
      [-58, 49],
      [38, 45],
      [9, 80],
      [-33, 64],
      [-118, 118],
      [-3, 99],
      [-27, 63],
      [-78, 73],
      [-236, 44],
      [-121, 9],
      [-273, -22],
      [-22, 38],
      [-59, 13],
      [-18, 28],
      [-98, 12],
      [-33, 37],
      [-112, 40],
      [-97, 72],
      [-44, 14],
      [36, 115],
      [-16, 66],
      [101, -21],
      [47, 49],
      [-41, 28],
      [-47, -28],
      [-37, 28],
      [-67, -64],
      [-42, 4],
      [-20, 44],
      [-92, 56],
      [-74, 7],
      [-118, -35],
      [-127, -86],
      [-106, -111],
      [-36, -58],
    ],
    [
      [18005, 11690],
      [-33, -65],
      [-119, -178],
      [-55, -114],
      [-33, -111],
      [-72, -127],
      [-79, -71],
    ],
    [
      [17614, 11024],
      [-29, 26],
      [-75, 8],
      [-97, -35],
      [-137, 39],
      [-76, -33],
      [9, -96],
      [-37, -92],
      [10, -55],
      [-107, -197],
      [38, -40],
      [-29, -41],
      [-47, 63],
      [-84, 17],
      [-54, -25],
      [-37, 6],
      [-4, -76],
      [-98, 57],
      [-48, -30],
      [-85, -26],
      [-52, 4],
      [-54, 61],
      [-28, 79],
      [41, 87],
      [-90, -26],
      [-90, 44],
      [-53, -46],
      [-94, 54],
      [-43, -6],
      [-44, -72],
      [-42, -38],
      [-28, -77],
    ],
    [
      [16050, 10558],
      [-37, 48],
      [-23, 72],
      [-82, 94],
      [4, 35],
      [-57, 30],
    ],
    [
      [15855, 10837],
      [49, 34],
      [-6, 45],
      [65, 106],
      [-7, 104],
      [19, 40],
      [108, 93],
      [55, 82],
      [-19, 84],
      [-79, 28],
      [-71, 91],
      [2, 97],
      [-188, 137],
      [-45, 83],
      [-68, 44],
      [20, 50],
      [-9, 54],
      [-62, 129],
      [-61, 16],
      [-41, 44],
      [28, 67],
      [63, 57],
      [-132, 71],
      [-46, 56],
      [-37, 19],
      [-4, 64],
      [17, 40],
      [-6, 57],
      [-89, 103],
      [76, 14],
      [10, 85],
      [56, 12],
      [87, -27],
      [4, 47],
      [104, 43],
      [37, 108],
      [34, 37],
      [9, 72],
      [-51, 136],
    ],
    [
      [17614, 11024],
      [-69, -96],
      [-11, -102],
      [34, -145],
      [20, -23],
      [-46, -87],
      [-64, -70],
      [-67, -96],
      [-63, -113],
      [-12, -53],
      [8, -96],
      [64, -61],
      [-6, -155],
      [157, -89],
      [129, -3],
      [91, -13],
      [29, 20],
      [46, -23],
      [63, -61],
      [14, -47],
      [80, -79],
      [184, -107],
      [75, -13],
      [64, -114],
      [113, -78],
      [64, -16],
      [-30, -49],
      [-47, -145],
      [-9, -154],
      [72, -111],
      [-55, -150],
      [-9, -113],
      [41, -86],
      [68, -63],
      [50, -16],
      [-48, -45],
      [-25, -68],
      [18, -64],
      [-38, -21],
      [-61, -81],
      [-36, -9],
      [-88, 32],
      [-38, -33],
      [-65, 77],
      [-45, 4],
      [-207, -53],
      [-164, -79],
      [-124, -92],
      [-128, -78],
      [-59, -96],
      [-1, -44],
      [-58, -76],
      [-4, -44],
      [41, -59],
      [-5, -60],
      [30, -204],
      [-1, -86],
      [19, -178],
      [-28, -82],
      [-121, -150],
      [-81, -62],
      [-226, -96],
      [-91, -131],
      [-196, -260],
      [-28, -237],
      [-77, -169],
      [-66, -86],
      [-119, -20],
      [-128, 33],
      [-173, -25],
      [-107, -6],
      [-94, 47],
      [-56, 42],
      [-70, 114],
      [-7, 38],
      [34, 32],
      [-6, 87],
      [-28, 21],
      [-6, 64],
      [45, 77],
      [-7, 53],
      [-35, 80],
      [5, 99],
      [113, 49],
      [86, 9],
      [81, 56],
      [60, 104],
      [12, 96],
      [23, 17],
      [58, 142],
      [36, 19],
      [30, 168],
      [22, 75],
      [-115, 122],
      [-67, 81],
      [42, 88],
      [75, 44],
      [95, 25],
      [65, 76],
      [98, 10],
      [103, -39],
      [60, 14],
      [89, 77],
      [45, 119],
      [19, 84],
      [0, 183],
      [-40, 51],
      [-76, 47],
      [-45, 115],
      [-49, 60],
      [-32, 161],
      [-31, 102],
      [-17, 323],
      [-37, 192],
      [-71, 219],
      [-58, 73],
      [-68, 127],
      [-73, 36],
      [-14, 25],
      [-76, 278],
      [-29, 19],
      [-12, 143],
      [-38, 189],
      [-30, 48],
      [37, 33],
      [-18, 103],
      [-42, 72],
    ],
    [
      [13336, 12081],
      [71, -45],
      [-97, -21],
      [26, 66],
    ],
    [
      [12736, 12555],
      [38, -23],
      [107, -23],
      [20, -72],
      [-76, -35],
      [-87, -2],
      [-34, 96],
      [32, 59],
    ],
    [
      [15855, 10837],
      [-47, 65],
      [-77, 23],
      [-68, -9],
      [-57, -25],
      [-42, -57],
      [-33, -15],
      [-70, -99],
      [-90, 11],
      [-45, 18],
      [-42, 60],
      [-63, 11],
      [-22, 94],
      [-52, 38],
      [-68, 82],
      [-40, 7],
      [-84, 106],
      [-27, 13],
      [-93, -29],
      [-63, 31],
      [-65, 96],
      [-59, 31],
      [-46, -6],
      [-49, 59],
      [71, 65],
      [-1, 133],
      [96, 53],
      [2, 73],
      [-28, 84],
      [-66, 120],
      [-67, 170],
      [-56, 102],
      [-92, 123],
      [-47, 47],
      [-68, 42],
      [-70, -26],
      [-47, -77],
      [-28, -4],
      [-69, 39],
      [-108, -76],
      [-92, -22],
      [-62, 46],
      [-124, -43],
      [-20, -25],
      [-147, -68],
      [-5, 43],
      [33, 87],
      [107, 33],
      [7, 43],
      [47, 24],
      [31, 52],
      [44, 10],
      [13, 40],
      [-47, 98],
      [-70, 3],
      [-139, 130],
      [-34, 46],
      [-61, 39],
      [-87, -23],
      [-42, -74],
      [-38, -23],
      [-42, 58],
      [-141, 30],
      [12, -98],
      [-74, 6],
      [0, 162],
      [-50, 165],
      [-72, 121],
      [-98, 113],
      [-45, 156],
      [-152, 235],
      [-82, 83],
    ],
    [
      [12545, 13657],
      [20, 48],
      [79, 7],
      [37, 42],
      [-21, 34],
      [50, 32],
      [46, 0],
      [22, 47],
      [-37, 59],
      [-5, 70],
      [26, 49],
      [-40, 59],
      [22, 39],
      [62, 5],
      [81, 69],
      [37, 12],
    ],
    [
      [12924, 14229],
      [49, -23],
      [21, -70],
      [44, -73],
      [72, 17],
      [42, 39],
      [-51, 73],
      [38, 82],
      [44, 62],
      [47, -59],
      [27, 28],
      [131, 6],
      [63, -26],
      [88, -78],
      [150, -29],
      [26, -29],
      [49, -3],
      [58, -88],
      [111, -27],
      [26, 30],
      [65, -67],
      [60, 62],
      [60, 40],
      [50, 10],
      [31, -24],
      [83, 39],
      [16, 68],
      [29, 16],
      [115, -66],
      [51, 48],
      [118, 31],
      [98, 68],
    ],
    [
      [10166, 20036],
      [-4, 14],
    ],
    [
      [10162, 20050],
      [4, -14],
    ],
    [
      [8437, 22547],
      [13, -49],
      [53, 15],
      [119, 2],
      [96, -60],
      [10, -46],
      [58, -7],
      [78, 59],
      [133, 55],
      [4, 50],
      [64, 15],
      [30, 27],
      [66, -7],
      [146, 5],
      [73, 29],
      [173, -41],
      [65, 4],
      [75, -103],
      [50, 33],
      [39, -39],
      [59, -7],
      [55, 47],
      [43, -2],
      [25, -39],
      [-22, -33],
      [8, -98],
      [30, -36],
      [57, -7],
      [37, -92],
      [71, -53],
    ],
    [
      [10145, 22169],
      [-41, 17],
      [-117, 101],
      [-40, -2],
      [0, -59],
      [-51, -86],
      [-24, -99],
      [-5, -123],
      [18, -78],
      [33, -58],
      [24, -110],
      [-7, -168],
      [16, -124],
      [48, -131],
      [13, -109],
      [39, -116],
      [21, -100],
      [58, -133],
      [213, -253],
      [78, -73],
      [39, -13],
      [101, -120],
      [91, -84],
      [53, -34],
      [63, -11],
    ],
    [
      [10768, 20203],
      [-42, -103],
      [12, -67],
      [-22, -84],
      [-70, -19],
      [-2, -59],
      [-102, -13],
      [-39, 67],
      [-22, 83],
      [-42, -12],
      [-130, 81],
    ],
    [
      [10309, 20077],
      [39, 79],
      [-17, 62],
      [-65, 10],
      [-59, -56],
      [-51, -13],
    ],
    [
      [10156, 20159],
      [-62, 33],
      [-29, -29],
      [-52, 24],
      [-49, -77],
      [-38, 3],
      [-107, -48],
      [-74, 38],
      [-4, -66],
      [-52, -119],
      [-13, -55],
      [-50, -87],
      [-11, -55],
      [19, -27],
    ],
    [
      [9634, 19694],
      [-53, -31],
      [-29, 30],
      [-89, 25],
      [-41, -5],
      [-59, 34],
      [-11, 35],
      [-160, 60],
      [-25, -19],
      [-101, 95],
      [-92, 37],
      [-38, 34],
      [12, 106],
      [-61, 39],
      [18, 36],
      [-66, 51],
      [-17, 35],
      [87, 109],
      [25, 75],
      [45, 45],
      [31, 86],
      [-131, 1],
      [-45, -51],
      [-97, 59],
      [24, 83],
      [-102, 13],
      [-65, -19],
      [-120, 100],
      [6, 52],
      [-53, 43],
      [-71, -94],
      [-67, 13],
      [-35, -55],
      [-74, -64],
      [-81, 7],
      [-61, -43],
      [90, -59],
      [-66, -40],
      [-95, 32],
      [-56, -6],
      [-67, -47],
      [-106, 14],
      [-49, 38],
      [-15, 56],
      [-85, -128],
      [-46, -45],
      [-27, 55],
      [-48, 34],
      [-127, 45],
      [-106, 89],
      [-124, -4],
      [-55, 12],
      [-30, -44],
      [-1, -50],
      [-54, -12],
      [-27, 40],
      [-93, 60],
      [-3, 42],
      [-67, 71],
      [-33, 60],
      [-54, -8],
      [-113, 103],
      [-50, 0],
      [-81, 39],
      [-76, -41],
      [-63, 86],
      [-87, 59],
      [-46, 58],
      [-76, -18],
      [-193, 138],
      [31, 66],
      [-46, 32],
      [-18, 46],
      [-70, 17],
      [-120, -1],
      [-75, -11],
      [-17, -37],
      [-137, -171],
      [-27, 9],
      [-53, -41],
    ],
    [
      [5377, 21154],
      [-21, -3],
      [-35, 112],
      [-85, 47],
      [-84, 16],
      [-114, -34],
      [-35, -28],
      [-28, 72],
      [21, 74],
      [47, 22],
      [13, 113],
      [-49, 84],
      [-58, 7],
      [-42, 28],
      [-25, 50],
      [-43, -57],
      [-72, 4],
      [-70, 70],
      [-49, -29],
      [-47, 57],
      [-75, -15],
    ],
    [
      [4526, 21744],
      [-5, 174],
    ],
    [
      [4521, 21918],
      [71, 5],
      [102, -18],
      [17, 59],
      [43, 70],
      [-82, 58],
      [2, 32],
      [52, 27],
      [7, 35],
      [59, 31],
      [-22, 139],
      [-91, 29],
      [-16, 33],
      [24, 65],
      [35, 32],
      [58, 145],
      [50, 54],
      [-9, 67],
      [120, 108],
      [110, 24],
      [54, -60],
      [62, 75],
      [35, -24],
      [94, 43],
      [-17, -71],
      [50, -14],
      [93, -56],
      [72, 67],
      [45, 7],
      [99, -42],
      [15, 59],
      [69, -53],
      [31, 48],
      [-37, 41],
      [3, 36],
      [60, 29],
      [37, -82],
      [61, 66],
      [38, -6],
      [64, -84],
      [-14, -42],
      [64, -85],
      [86, -46],
      [90, 52],
      [64, -38],
      [30, 14],
      [76, -36],
      [34, -47],
      [161, -79],
      [32, 31],
      [59, -3],
      [33, -83],
      [50, -14],
      [98, -58],
      [94, -9],
      [96, 36],
      [63, 106],
      [41, 43],
      [79, 12],
      [29, -69],
      [-8, -32],
      [138, -31],
      [120, -57],
      [47, 28],
      [43, -5],
      [99, 78],
      [108, -13],
      [25, 33],
      [89, -28],
      [50, -43],
      [156, 30],
      [54, -18],
      [22, 44],
      [74, 13],
      [54, -29],
      [37, 19],
      [85, -19],
    ],
    [
      [11708, 24425],
      [60, -38],
      [-35, -54],
      [-44, 50],
      [19, 42],
    ],
    [
      [11351, 24231],
      [-69, 67],
      [-27, 121],
      [-48, 32],
      [11, 41],
      [-35, 25],
      [-30, 125],
      [-73, -27],
      [-68, 15],
      [-52, 65],
      [-100, -14],
      [-39, 22],
      [-69, -65],
      [-24, 23],
      [-88, -100],
      [-129, 104],
      [-42, -33],
      [-40, 4],
      [0, 50],
      [-39, 52],
      [-56, 130],
      [-74, 27],
      [-72, 52],
      [11, 94],
      [-41, 112],
      [40, 80],
      [98, 65],
      [27, 82],
      [-13, 45],
      [-61, 33],
      [-46, 93],
      [-49, 44],
      [-54, -10],
      [-85, 74],
      [10, 68],
      [38, 25],
      [7, 54],
      [42, 36],
      [58, 0],
      [29, 48],
      [61, 42],
      [-4, 26],
      [61, 76],
      [18, 69],
      [113, 82],
      [65, -27],
      [83, 48],
      [-41, 67],
      [151, 79],
      [28, 40],
      [17, 80],
      [-20, 32],
      [8, 62],
    ],
    [
      [10739, 26566],
      [32, 29],
      [68, -10],
      [62, -33],
      [41, -60],
      [139, 12],
      [94, -21],
      [65, 7],
      [45, -19],
      [81, 11],
      [131, -26],
      [128, -79],
      [59, 17],
      [66, -21],
      [119, 56],
      [80, -44],
      [85, 0],
      [160, -17],
      [126, -29],
      [74, -41],
      [65, -1],
      [-4, -113],
      [-48, -90],
      [-31, 42],
      [-40, -17],
      [-88, 0],
      [-31, -18],
      [-56, -96],
      [-76, -33],
      [-74, -55],
      [-54, -82],
      [-82, -87],
      [67, -134],
      [-12, -45],
      [48, -10],
      [39, 55],
      [103, -41],
      [59, -56],
      [171, -32],
      [14, -75],
      [-30, -37],
      [-128, -115],
      [-126, -66],
      [4, -66],
      [-39, -94],
      [119, -21],
      [122, 27],
      [66, -28],
      [-40, -150],
      [-26, -35],
      [-40, -106],
      [-5, -61],
      [34, -46],
      [99, -33],
      [149, -72],
      [129, -106],
      [49, -81],
      [70, -61],
      [31, -66],
      [-6, -35],
      [-62, -78],
      [-70, -34],
      [-75, 1],
      [-66, 30],
      [42, 90],
      [-45, 128],
      [-205, 198],
      [-150, 47],
      [-46, -53],
      [-6, -47],
      [58, -35],
      [-207, -116],
      [-86, -16],
      [1, 110],
      [-37, 31],
      [-88, 36],
      [-115, 4],
      [-46, 47],
      [-70, -16],
      [-161, -79],
      [-13, -95],
      [50, -10],
      [5, -42],
      [-53, -28],
    ],
    [
      [11177, 12970],
      [-43, -71],
      [-22, 28],
      [65, 43],
    ],
    [
      [9261, 17502],
      [17, -16],
      [47, -118],
      [84, -33],
      [-35, -84],
      [-58, -59],
      [26, -51],
      [65, -19],
      [91, -60],
      [128, 30],
      [38, -32],
      [65, 65],
      [76, -39],
      [68, -77],
      [-25, -41],
      [30, -26],
      [-13, -67],
      [64, -29],
      [-14, -65],
      [87, -105],
      [61, -35],
      [77, 61],
      [32, -49],
      [-3, -78],
      [19, -58],
      [69, 18],
      [35, -60],
      [53, -3],
      [13, -84],
      [85, 37],
      [83, 72],
      [-4, 54],
      [16, 78],
      [35, -2],
      [15, -59],
      [29, -5],
      [133, 70],
      [-44, 47],
      [19, 45],
      [81, 10],
      [-1, 43],
      [79, 4],
      [53, 47],
      [79, 26],
      [-23, 93],
      [29, 33],
      [62, -30],
      [38, 36],
      [90, -9],
      [19, 40],
      [76, -22],
      [77, 37],
      [50, 50],
      [24, -31],
      [53, 48],
      [-2, 50],
      [30, 54],
      [-1, 56],
    ],
    [
      [11538, 17260],
      [113, -28],
      [19, 44],
      [37, 1],
      [101, -93],
    ],
    [
      [12859, 14767],
      [84, -82],
      [14, -70],
      [25, -40],
      [-16, -90],
      [39, -21],
      [4, -84],
      [-94, -76],
      [35, -28],
      [-26, -47],
    ],
    [
      [12545, 13657],
      [-99, 71],
      [-41, -22],
      [-64, 35],
      [-45, 4],
      [-86, -51],
      [-2, -55],
      [-50, -7],
      [-55, 21],
      [-211, 128],
      [-97, 38],
      [-78, 14],
      [-62, -36],
      [-88, 3],
      [-93, -35],
      [-88, -69],
      [-15, -35],
      [-53, -8],
      [-45, 21],
      [-17, 79],
      [-63, 133],
      [-44, 65],
      [-81, 79],
      [-83, 57],
      [-73, 27],
      [-110, 2],
      [-14, -12],
      [-80, 67],
      [-90, 43],
      [-84, -27],
      [-27, 64],
      [-124, 193],
      [-166, 205],
      [-156, 142],
      [-213, 126],
      [-30, 147],
      [-37, 100],
      [-52, 95],
      [-76, 82],
      [-121, 64],
      [-61, 76],
      [-72, 27],
      [-15, 33],
      [-88, 61],
      [-39, 2],
      [-105, -25],
      [-61, 135],
      [-21, 6],
      [-95, 162],
      [11, 38],
      [-34, 35],
      [-24, 75],
      [-73, 117],
      [-51, 60],
      [-151, 118],
      [-176, 85],
    ],
    [
      [8477, 16410],
      [13, 59],
      [44, 43],
      [12, 47],
      [49, -14],
      [67, 13],
      [111, -7],
      [-2, 123],
      [-97, 71],
      [40, 60],
      [-10, 56],
      [66, -15],
      [123, 60],
      [46, 62],
      [37, -11],
      [46, 76],
      [38, -8],
      [50, 43],
      [-42, 42],
      [-6, 88],
      [33, 3],
      [32, 82],
      [-70, 36],
      [-58, 66],
      [49, 84],
      [51, -48],
      [79, 90],
      [83, -9],
    ],
    [
      [5377, 21154],
      [34, 0],
      [41, -90],
      [135, -109],
      [85, -35],
      [8, -73],
      [29, -32],
      [-32, -72],
      [90, 38],
      [34, -33],
      [-63, -66],
      [131, 3],
      [17, -71],
      [45, -76],
      [35, 28],
      [45, -10],
      [39, -41],
      [-13, -43],
      [-77, -87],
    ],
    [
      [5960, 20385],
      [-29, 15],
      [-69, -33],
      [-143, 104],
      [-51, 57],
      [-55, -22],
      [30, -63],
      [-29, -27],
      [-86, 42],
      [-84, 87],
      [-103, 73],
      [-56, -19],
      [-51, 53],
      [-1, 37],
      [-68, 25],
      [-31, 57],
      [-34, 1],
      [-63, 68],
      [-90, 6],
      [-35, 51],
      [-41, 6],
      [-18, 47],
      [-269, 151],
      [-40, -25],
      [-23, -73],
      [-95, 45],
      [13, 61],
      [-22, 29],
      [-67, 25],
      [-299, 56],
      [-37, 27],
      [-128, 13],
      [-19, 30],
      [-94, -10],
      [-56, 18],
      [-88, -43],
      [-24, -39],
      [-67, -13],
      [-29, -35],
      [-96, -37],
      [-51, -53],
      [-61, -16],
      [-29, -54],
      [-71, -41],
      [11, -67],
      [-68, -81],
      [-3, -59],
      [-56, -49],
      [-194, -90],
      [-47, -66],
      [-37, -87],
      [-3, -88],
      [-100, -99],
      [-13, -69],
      [24, -42],
      [-56, -15],
      [-24, -50],
      [-56, -20],
      [-39, -63],
      [-78, -18],
      [-21, -27],
      [-86, -33],
      [-102, -55],
      [-69, -1],
      [-69, -48],
      [-47, 17],
      [-91, -37],
      [-28, -29],
      [-46, 13],
      [-69, -58],
      [-146, 37],
      [-56, -25],
      [-51, 7],
      [-54, 210],
      [27, 28],
      [83, 37],
      [18, 109],
      [71, 27],
      [71, 47],
      [29, 51],
      [-6, 76],
      [63, 32],
      [20, 48],
    ],
    [
      [1903, 20429],
      [50, 37],
      [-37, 64],
      [47, 74],
      [52, 11],
      [70, -40],
      [195, -31],
      [16, -22],
      [64, 29],
      [57, -26],
      [5, 56],
      [-49, 19],
      [54, 52],
      [59, -30],
      [42, 4],
      [48, 73],
      [-11, 67],
      [-40, 33],
      [27, 59],
      [-31, 27],
      [47, 49],
      [-53, 64],
      [29, 32],
      [45, -31],
      [9, 76],
      [48, -2],
      [25, 54],
      [2, 72],
      [95, 48],
      [32, 59],
      [-46, 82],
      [49, 51],
      [1, 68],
      [51, 35],
      [33, -53],
      [58, -9],
      [28, -34],
      [52, -9],
      [15, -47],
      [59, 29],
      [20, 76],
      [81, -28],
      [59, 33],
      [91, 5],
      [44, -25],
      [24, 49],
      [70, 56],
      [-22, 50],
      [34, 22],
      [82, 13],
      [26, -18],
      [69, 12],
      [83, -133],
      [2, -82],
      [48, 25],
      [-2, 52],
      [51, 40],
      [4, 55],
      [101, -23],
      [66, 36],
      [-68, 171],
      [45, 19],
      [40, 70],
      [48, 0],
      [25, -31],
      [71, 9],
      [73, -109],
      [37, 6],
      [48, -34],
      [18, -68],
      [69, -16],
      [93, 62],
      [-4, 31],
    ],
    [
      [6729, 26328],
      [4, -59],
      [32, -36],
      [134, -10],
      [85, -54],
      [37, -49],
      [-9, -45],
      [25, -64],
      [-41, -55],
      [-71, -4],
      [-59, -52],
      [-10, -33],
      [67, -38],
      [24, -65],
      [-6, -58],
      [17, -64],
      [-78, -141],
      [42, -51],
      [-31, -50],
      [-11, -103],
      [-89, -86],
      [-8, -89],
      [-51, -50],
      [-7, -77],
      [55, -14],
      [12, -89],
      [29, -67],
      [-30, -55],
      [20, -26],
      [11, -113],
      [36, 6],
      [7, -91],
      [54, -10],
      [65, 45],
      [89, 23],
      [6, 48],
      [170, 9],
      [157, -9],
    ],
    [
      [7406, 24652],
      [-120, -195],
      [-123, -186],
      [-125, -151],
      [-5, -18],
      [26, -352],
      [38, -63],
      [90, -28],
      [2, -49],
      [-34, -37],
      [30, -110],
      [29, -45],
      [11, -67],
      [80, 67],
      [59, -51],
      [53, -89],
      [88, -23],
      [66, -33],
      [22, -65],
      [77, -23],
      [13, -90],
      [92, -21],
      [-38, -63],
      [78, -58],
      [57, 24],
      [39, -14],
      [20, 50],
      [88, -34],
      [-3, -65],
      [25, -53],
      [59, -38],
      [39, 23],
      [32, -88],
      [67, -18],
      [32, -41],
      [146, -60],
      [21, -41],
    ],
    [
      [4521, 21918],
      [5, 85],
      [19, 72],
      [-74, 47],
      [3, 58],
      [-23, 42],
      [-90, -20],
      [-59, 39],
      [-40, 54],
      [30, 50],
      [-25, 57],
      [-45, -2],
      [-54, 50],
      [-14, 51],
      [-39, 30],
      [15, 57],
      [-52, 51],
      [-41, -12],
      [-42, 58],
      [-2, 85],
      [-33, 25],
      [-101, -18],
      [-97, -95],
      [-31, 33],
      [-81, 40],
      [-93, -33],
      [-31, 42],
      [20, 82],
      [-66, 79],
      [-50, 105],
      [-43, 11],
      [-20, 58],
      [33, 35],
      [-65, 55],
      [30, 79],
      [-54, 92],
      [-8, 40],
      [54, 28],
      [-20, 58],
      [41, 26],
      [50, -18],
      [58, 17],
      [77, -68],
      [19, -80],
      [88, 26],
      [18, 71],
      [60, 45],
      [-70, 45],
      [128, 20],
      [87, 35],
      [-95, 163],
      [-3, 58],
      [-105, 38],
      [-26, 42],
      [-16, 161],
      [-32, 72],
      [5, 53],
      [-44, 83],
      [-40, 5],
      [24, 74],
      [-15, 34],
      [-77, 10],
      [-82, 117],
      [14, 76],
      [56, 63],
      [-41, 128],
      [39, 83],
      [220, 213],
      [17, 43],
      [-41, 124],
      [20, 49],
    ],
    [
      [3671, 25294],
      [45, 53],
      [68, -64],
      [52, 7],
      [70, -60],
      [-56, -114],
      [-50, -44],
      [1, -38],
      [65, -10],
      [54, -63],
      [49, -17],
      [-2, -56],
      [53, -40],
      [28, -99],
      [-38, -72],
      [74, 5],
      [70, -56],
      [61, 0],
      [6, 49],
      [39, 81],
      [40, 27],
      [-4, 65],
      [-56, 34],
      [-41, 1],
      [-9, 73],
      [-42, 29],
      [65, 50],
      [-28, 100],
      [19, 39],
      [101, 32],
      [20, 42],
      [-29, 80],
      [86, 41],
      [23, 45],
      [52, 39],
      [50, -3],
      [16, 75],
      [32, 51],
      [45, 27],
      [22, 99],
      [68, 100],
      [0, 90],
      [-30, 29],
      [9, 45],
      [-13, 83],
      [-49, 41],
      [0, 32],
      [50, 36],
      [12, 94],
      [47, 8],
      [107, -12],
      [29, -65],
      [40, -11],
      [24, 54],
      [68, 50],
      [1, -91],
      [-19, -110],
      [29, -123],
      [47, -18],
      [37, -88],
      [53, -56],
      [159, -39],
      [59, 33],
      [73, -18],
      [21, 110],
      [40, 18],
      [37, -31],
      [174, 64],
      [59, 42],
      [39, -33],
      [36, 24],
      [81, -85],
      [9, -135],
      [103, -45],
      [-12, -90],
      [38, -24],
      [42, 26],
      [52, -11],
      [89, 71],
      [-37, 93],
      [-65, 52],
      [-21, 45],
      [44, 105],
      [61, 28],
      [4, 46],
      [-60, 50],
      [-89, -21],
      [-74, 48],
      [6, 85],
      [27, 160],
      [62, 74],
      [13, 83],
      [44, -11],
      [103, 45],
      [58, -16],
      [36, 37],
      [37, -54],
      [-27, -45],
      [93, -95],
      [101, 9],
      [76, -25],
      [37, 12],
      [69, -44],
    ],
    [
      [11538, 17260],
      [11, 56],
      [36, 35],
      [51, -9],
      [33, 97],
      [-29, 98],
      [-153, -42],
      [-85, 137],
      [-56, 24],
      [-46, 49],
      [-138, -119],
      [-13, 73],
      [14, 60],
      [-142, 93],
      [22, 48],
      [-36, 59],
      [33, 61],
      [-29, 56],
      [13, 83],
      [-39, 71],
      [-57, -2],
      [-21, 45],
      [55, 59],
      [0, 108],
      [-45, 15],
      [-21, 117],
      [-62, 43],
      [22, 55],
      [-97, 197],
      [49, 28],
      [-15, 57],
      [2, 81],
      [-57, 11],
      [-46, -95],
      [-80, 29],
      [-66, -38],
      [-108, 93],
      [-113, 147],
      [-75, -10],
      [-34, 50],
      [-30, -5],
      [-39, -55],
      [-57, 50],
      [-59, -25],
      [-35, 46],
      [56, 25],
      [50, 74],
      [-29, 78],
      [-110, -57],
      [-121, 0],
      [-20, 41],
    ],
    [
      [9822, 19352],
      [-50, 75],
      [61, 21],
      [129, 80],
      [68, -24],
      [-4, 78],
      [67, 19],
      [-72, 86],
      [-76, 33],
      [-75, -27],
      [-57, 9],
      [-23, -59],
      [-56, 71],
      [-71, -31],
      [-29, 11],
    ],
    [
      [10156, 20159],
      [6, -109],
    ],
    [
      [10166, 20036],
      [48, 16],
      [30, -24],
      [55, 12],
      [10, 37],
    ],
    [
      [10768, 20203],
      [87, -11],
      [164, -100],
      [17, 5],
      [104, -106],
      [191, -146],
      [53, -57],
      [297, -257],
      [261, -156],
      [107, -33],
      [49, 54],
      [35, -19],
      [65, -78],
      [9, -41],
      [102, -57],
      [-9, -116],
      [74, -151],
      [45, -146],
      [47, -123],
      [30, -38],
      [72, -164],
      [20, -76],
      [101, -258],
      [10, -92],
      [68, -280],
      [46, -112],
    ],
    [
      [9795, 19734],
      [68, 39],
      [2, 30],
      [-121, 12],
      [51, -81],
    ],
    [
      [14333, 15676],
      [124, -81],
      [187, -63],
      [76, -34],
      [90, -72],
      [34, -44],
      [118, -49],
    ],
    [
      [1903, 20429],
      [3, 59],
      [-80, 96],
      [27, 118],
      [-88, -3],
      [-35, -52],
      [-79, 5],
      [-110, -26],
      [-79, -43],
      [-52, 4],
      [-35, -27],
      [-47, 14],
      [-45, -16],
      [-27, 69],
      [-142, 4],
      [-39, 55],
      [-40, 3],
      [-41, 61],
      [-95, 10],
      [-115, 72],
      [-68, -15],
      [-47, 43],
      [-14, 85],
      [-61, 47],
      [-2, 33],
      [-49, 48],
      [-13, 51],
      [-57, 28],
      [15, 33],
      [-2, 95],
      [81, 23],
      [-63, 99],
      [-50, 35],
      [-38, 109],
      [39, 54],
      [54, 11],
      [37, 42],
      [36, 108],
      [-15, 77],
      [82, 79],
      [54, 9],
      [52, -24],
      [25, 27],
      [-17, 47],
      [-71, 85],
      [2, 63],
      [-29, 46],
      [23, 72],
      [-32, 40],
      [-97, 57],
      [-65, -44],
      [-74, 20],
      [-78, 44],
      [-23, 34],
      [-88, 65],
      [1, 136],
      [-41, 126],
      [-93, -6],
      [-28, 95],
      [-70, 115],
      [73, 32],
      [32, 38],
      [97, 1],
      [48, 37],
      [51, -8],
      [92, -53],
      [71, 26],
      [11, 59],
      [93, 27],
      [39, 78],
      [132, 40],
      [27, -33],
      [79, 79],
      [42, 24],
      [0, 65],
      [-39, 96],
      [127, 195],
      [-11, 22],
      [-101, 58],
      [-35, 67],
    ],
    [
      [828, 23774],
      [23, 20],
      [14, 80],
      [68, -47],
      [111, -38],
      [81, 105],
      [91, -2],
      [67, 28],
      [26, -22],
      [80, 73],
      [50, 20],
      [30, 52],
      [60, 14],
      [41, -16],
      [61, 33],
      [74, -28],
      [17, -37],
      [65, 14],
      [55, -40],
      [80, 14],
      [18, -18],
      [92, 58],
      [19, 28],
      [93, 38],
      [84, -6],
      [34, 79],
      [41, 24],
      [-60, 93],
      [56, 101],
      [-14, 43],
      [-77, 42],
      [-39, 74],
      [2, 116],
      [21, 52],
      [-25, 126],
      [21, 36],
    ],
    [
      [2188, 24883],
      [-9, 27],
      [23, 85],
      [49, 49],
      [147, 3],
      [41, 75],
      [36, 30],
      [-19, 53],
      [23, 71],
      [127, 34],
      [15, 43],
      [46, 15],
      [37, 114],
      [-44, 98],
      [-85, 92],
      [88, 91],
      [64, -10],
      [63, 28],
      [22, 63],
      [62, 30],
      [0, 38],
      [87, 45],
      [5, 47],
      [-45, 23],
      [146, 104],
      [35, -12],
      [68, 28],
      [64, -20],
      [-23, -68],
      [26, -142],
      [-11, -72],
      [-67, -86],
      [46, -87],
      [-26, -35],
      [45, -49],
      [122, -15],
      [15, -51],
      [114, -113],
      [-22, -33],
      [27, -56],
      [66, 16],
      [16, -25],
      [109, -17],
    ],
    [
      [3056, 8624],
      [21, -34],
      [72, 21],
      [61, -55],
      [21, -92],
      [-25, -47],
      [-15, -135],
      [-28, -25],
      [-46, 5],
      [-69, 167],
      [-21, 98],
      [29, 97],
    ],
    [
      [2952, 8802],
      [5, -87],
      [-10, -119],
      [-60, -15],
      [-45, 31],
      [5, 56],
      [-53, 33],
      [17, 48],
      [141, 53],
    ],
    [
      [2969, 13412],
      [35, -147],
      [-54, -6],
      [-40, 19],
      [-71, -88],
      [35, -63],
      [-18, -37],
      [-58, 9],
      [-20, 32],
      [25, 97],
      [48, 21],
      [58, 70],
      [-22, 37],
      [52, 18],
      [30, 38],
    ],
    [
      [4996, 13710],
      [19, -19],
      [-5, -93],
      [-42, -34],
      [-22, 43],
      [29, 101],
      [21, 2],
    ],
    [
      [4566, 13742],
      [94, -74],
      [-18, -79],
      [17, -17],
      [84, 4],
      [21, 38],
      [45, 3],
      [29, -46],
      [75, -39],
      [36, -86],
      [8, -68],
      [57, 80],
      [61, 5],
      [53, -24],
      [41, -55],
      [-16, -65],
      [-46, 1],
      [-20, -80],
      [15, -52],
      [58, -2],
      [25, -48],
      [50, 32],
      [25, -42],
      [-68, -44],
      [19, -36],
      [-46, -63],
      [-112, -31],
      [3, -42],
      [97, 16],
      [51, -45],
      [49, 51],
      [9, -61],
      [52, -97],
      [57, 13],
      [13, -117],
      [-55, -13],
      [51, -102],
      [45, -22],
      [-8, -97],
      [68, -75],
      [-14, -126],
      [34, -98],
      [53, -39],
      [11, -68],
      [54, -28],
      [-7, -67],
      [-54, -143],
      [-36, -40],
      [2, -43],
      [-35, -64],
      [-45, -16],
      [-66, -67],
      [-105, -170],
      [-12, -84],
      [12, -127],
      [42, -102],
      [75, -96],
      [56, -29],
      [13, -36],
      [-53, -98],
      [-12, -81],
      [-23, -41],
      [-4, -65],
      [19, -45],
      [-22, -70],
      [3, -161],
      [-29, -154],
      [13, -57],
      [-7, -121],
      [-35, -89],
      [10, -225],
      [-32, -71],
      [-12, -103],
      [23, -19],
      [-5, -106],
      [-29, -36],
      [-36, -103],
      [-17, -93],
      [17, -127],
      [-59, -112],
      [-15, -134],
      [7, -105],
      [-66, -45],
      [-81, 18],
      [-39, -21],
      [-121, 40],
      [-38, 71],
      [-133, 96],
      [-91, 9],
      [-48, 26],
      [-79, -42],
      [-54, -58],
      [-34, 51],
      [-46, 16],
      [-32, 78],
      [-27, -21],
      [-46, 68],
      [-41, -1],
      [50, -78],
      [61, -5],
      [29, -45],
      [-68, -61],
      [-61, -92],
      [-17, -64],
      [13, -83],
      [51, -67],
      [-35, -86],
      [3, -57],
      [-204, -196],
      [-13, -29],
      [-110, -68],
      [-41, 44],
      [-37, -9],
      [-63, 61],
      [-53, 33],
      [-63, -27],
      [-50, -59],
      [-106, -4],
      [26, 65],
      [2, 53],
      [-21, 44],
      [-65, 40],
      [-16, 59],
      [21, 43],
      [-21, 62],
      [-45, 31],
      [-107, 4],
      [18, 56],
      [-44, 88],
      [-52, 22],
      [7, 61],
      [-62, 46],
      [-10, 56],
      [-50, 33],
      [-3, 38],
      [102, 95],
      [22, 50],
      [-38, 110],
      [-37, 8],
      [-38, 88],
      [53, 70],
      [18, 80],
      [-44, 21],
      [-7, 54],
      [91, 128],
      [31, 64],
      [31, 121],
      [-35, 51],
      [5, 181],
      [-18, 127],
      [26, 42],
      [109, -182],
      [20, 27],
      [-49, 57],
      [67, 104],
      [25, 180],
      [-28, 103],
      [-59, 42],
      [34, 62],
      [-51, 35],
      [-10, 71],
      [-55, -85],
      [47, -76],
      [-69, -8],
      [-38, -35],
      [-48, 20],
      [4, 142],
      [-15, 34],
      [32, 61],
      [-6, 67],
      [20, 30],
      [59, 20],
      [65, 67],
      [-9, 96],
      [-44, 77],
      [3, 151],
      [39, 173],
      [-98, 117],
      [-73, 23],
      [-9, 42],
      [33, 91],
      [-8, 92],
      [-37, 123],
      [-70, 55],
      [-68, 189],
      [-79, -22],
      [-15, -36],
      [-78, 5],
      [38, 75],
      [-19, 31],
      [-104, -80],
      [-10, 97],
      [74, 38],
      [31, 120],
      [-116, 92],
      [48, 98],
      [-2, 53],
      [54, 86],
      [42, 100],
      [6, 56],
      [-80, 100],
      [47, 92],
      [61, -46],
      [-16, -46],
      [7, -65],
      [43, -57],
      [101, -92],
      [77, -16],
      [104, 2],
      [58, -41],
      [153, 9],
      [78, 31],
      [72, 56],
      [42, 64],
      [102, 55],
      [72, 18],
      [41, -7],
      [70, 39],
      [115, 153],
      [14, 77],
      [92, 40],
      [58, 70],
      [79, 120],
      [55, 31],
      [29, -27],
      [83, 17],
      [37, 45],
      [44, 6],
      [17, 192],
      [58, 16],
      [55, 40],
    ],
    [
      [4904, 13765],
      [43, -76],
      [-6, -50],
      [-104, -14],
      [15, 55],
      [52, 85],
    ],
    [
      [10389, 77],
      [148, -18],
      [21, -54],
      [-77, -5],
      [-92, 77],
    ],
    [
      [9361, 3203],
      [81, -45],
      [26, 6],
      [65, -57],
      [8, -92],
      [-58, -65],
      [-72, 25],
      [-24, 53],
      [-73, 84],
      [5, 59],
      [42, 32],
    ],
    [
      [9986, 5863],
      [109, -80],
      [-25, -44],
      [-35, 36],
      [-88, -10],
      [-26, 51],
      [65, 47],
    ],
    [
      [9556, 5953],
      [29, -85],
      [-62, 1],
      [-28, 83],
      [61, 1],
    ],
    [
      [15676, 6688],
      [110, -65],
      [81, -22],
      [-116, -40],
      [-24, -34],
      [-25, -87],
      [8, -33],
      [-75, -138],
      [-30, -88],
      [-44, -82],
      [-65, -73],
      [-162, -241],
      [-7, -33],
      [-66, -71],
      [-68, -115],
      [9, -29],
      [-53, -55],
      [-69, -132],
      [26, -77],
      [-29, -60],
      [-6, -68],
      [-43, -53],
      [3, -136],
      [-55, -73],
      [-52, -34],
      [-55, -115],
      [12, -181],
      [-2, -113],
      [25, -116],
      [54, -2],
      [51, -51],
      [106, -43],
      [56, -66],
      [-114, -17],
      [-11, -95],
      [30, -43],
      [4, -54],
      [59, -94],
      [98, -19],
      [14, -65],
      [-37, -110],
      [62, 7],
      [-23, -53],
      [-67, -46],
      [-10, -53],
      [-42, -3],
      [-84, -61],
      [-52, -66],
      [-36, -124],
      [-54, -63],
      [-1, -84],
      [-21, -18],
      [13, -87],
      [34, -47],
      [7, -96],
      [26, -41],
      [-98, -82],
      [-46, 29],
      [-13, 42],
      [-47, 48],
      [-119, -15],
      [-77, 72],
      [-104, 14],
      [-44, -35],
      [-76, -26],
      [-70, 40],
      [-101, 2],
      [-27, 48],
      [-73, 56],
      [-131, 41],
      [-110, 9],
      [-62, 71],
      [3, 28],
      [-41, 134],
      [-108, 194],
      [-136, 167],
      [-98, 74],
      [-149, 71],
      [-153, 35],
      [-63, -8],
      [-102, 4],
      [-79, -34],
      [-50, 1],
      [-79, 39],
      [-24, 51],
      [-38, 28],
      [-128, 11],
      [-45, 50],
      [-113, 57],
      [-39, 86],
      [-29, 9],
      [-123, 127],
      [-72, 12],
      [-57, -11],
      [-55, 14],
      [-75, 90],
      [-74, 41],
      [-25, 30],
      [-47, 6],
      [-48, 61],
      [-38, -1],
      [-22, 65],
      [-42, 42],
      [-39, 68],
      [-32, 6],
      [-41, 60],
      [-73, 7],
      [-95, 31],
      [-68, -25],
      [-43, 34],
      [-48, 79],
      [-69, 68],
      [-155, 29],
      [-139, -5],
      [-190, -51],
      [-77, 99],
      [-26, 83],
      [-88, 62],
      [-79, -4],
      [-85, 106],
      [2, 93],
      [-38, 84],
      [-46, 56],
      [67, 33],
      [4, 76],
      [34, 23],
      [-32, 134],
      [51, 99],
      [-2, 62],
      [78, 28],
      [-38, 49],
      [78, 123],
      [87, 0],
      [59, 30],
      [33, 84],
      [85, -8],
      [47, 75],
      [-33, 60],
      [87, 34],
      [-1, -43],
      [42, -65],
      [-2, -60],
      [68, -107],
      [116, -98],
      [107, 21],
      [170, 94],
      [44, 38],
      [-38, 104],
      [86, 142],
      [97, -13],
      [8, -37],
      [50, -2],
      [71, 30],
      [18, 40],
      [52, -2],
      [39, 48],
      [40, 16],
      [14, -50],
      [59, -30],
      [30, -95],
      [-18, -59],
      [32, -44],
      [99, -32],
      [87, 16],
      [28, 40],
      [57, -14],
      [4, -130],
      [45, -46],
      [99, -68],
      [215, -96],
      [158, 30],
      [119, 57],
      [75, 50],
      [65, 4],
      [91, 27],
      [53, -51],
      [79, -9],
      [81, 21],
      [130, -33],
      [76, 6],
      [73, -10],
      [51, 26],
      [55, -8],
      [87, 57],
      [89, -17],
      [105, 29],
      [32, 30],
      [59, 3],
      [80, 27],
      [78, 63],
      [124, 161],
      [74, -30],
      [183, 51],
      [41, 45],
      [56, -35],
      [39, -59],
      [138, -4],
      [23, -54],
      [40, -18],
      [54, 15],
      [100, 57],
      [79, 90],
      [22, 48],
      [112, -6],
      [103, 24],
      [173, 82],
      [127, 114],
      [39, 8],
    ],
    [
      [14651, 7001],
      [-1, -35],
      [65, -48],
      [18, -54],
      [-53, -18],
      [-48, 36],
      [-24, 50],
      [43, 69],
    ],
    [
      [14652, 7218],
      [8, -42],
      [-17, -161],
      [-41, 52],
      [-60, 42],
      [14, 86],
      [96, 23],
    ],
    [
      [14399, 7363],
      [99, -8],
      [-3, -106],
      [-29, -8],
      [-105, 65],
      [38, 57],
    ],
    [
      [13925, 7367],
      [55, -18],
      [-7, -51],
      [-36, 3],
      [-12, 66],
    ],
    [
      [11521, 7688],
      [24, -44],
      [-66, -26],
      [4, 44],
      [38, 26],
    ],
    [
      [15109, 7905],
      [38, -16],
      [-27, -68],
      [-26, -13],
      [-44, 50],
      [59, 47],
    ],
    [
      [6478, 16346],
      [26, -21],
      [-18, -63],
      [-53, 39],
      [45, 45],
    ],
    [
      [7485, 16438],
      [36, -21],
      [44, -100],
      [-50, -32],
      [-38, 63],
      [8, 90],
    ],
    [
      [6653, 17591],
      [54, -62],
      [-20, -46],
      [4, -107],
      [-57, -61],
      [56, -53],
      [2, -42],
      [-91, -9],
      [-71, 119],
      [-92, -26],
      [-8, -44],
      [-75, 38],
      [-38, -53],
      [-31, 18],
      [-119, -10],
      [-61, 83],
      [1, 49],
      [31, 37],
      [53, 14],
      [98, -2],
      [25, -34],
      [50, 17],
      [50, 54],
      [66, -5],
      [44, -58],
      [30, 6],
      [57, 122],
      [42, 55],
    ],
    [
      [5620, 18068],
      [37, -59],
      [-9, -54],
      [-48, -53],
      [-34, 38],
      [11, 78],
      [43, 50],
    ],
    [
      [9822, 19352],
      [-19, -10],
      [-71, -107],
      [-17, -67],
      [-89, -8],
      [-13, -73],
      [87, -47],
      [-6, -26],
      [-66, -20],
      [-39, -63],
      [-44, 10],
      [-55, -54],
      [13, -36],
      [79, -4],
      [-8, -67],
      [80, -15],
      [32, -83],
      [-9, -84],
      [82, -27],
      [30, 75],
      [50, -43],
      [-24, -33],
      [-62, -23],
      [-46, -44],
      [-47, 2],
      [-63, -45],
      [-66, 40],
      [-37, -147],
      [-68, -24],
      [-114, -80],
      [-15, -53],
      [26, -75],
      [-14, -31],
      [25, -61],
      [35, 31],
      [43, -30],
      [-47, -185],
      [-5, -73],
      [-33, -94],
      [46, -40],
      [0, -49],
      [-52, -5],
      [-60, -82],
    ],
    [
      [8477, 16410],
      [-125, 44],
      [-175, 30],
      [-55, 25],
      [-49, -14],
      [-57, -98],
      [-52, -25],
      [-72, 67],
      [-38, 6],
      [-12, 80],
      [47, 33],
      [75, -13],
      [50, 89],
      [9, 91],
      [-60, 124],
      [-62, -13],
      [-57, 118],
      [-8, 51],
      [-136, 82],
      [-38, 113],
      [-42, 53],
      [-111, 61],
      [-111, 33],
      [-95, 14],
      [-71, 53],
      [53, 75],
      [-7, 92],
      [28, 62],
      [-17, 32],
      [-129, 84],
      [-94, 23],
      [-155, -6],
      [-25, -69],
      [-90, 23],
      [-21, 122],
      [58, 35],
      [30, 136],
      [12, 125],
      [-4, 206],
      [-13, 88],
      [-42, 132],
      [-73, 76],
      [-15, 65],
      [-55, 131],
      [-35, 3],
      [-8, 56],
      [-33, 53],
      [-90, 65],
      [-25, 103],
      [-39, 73],
      [16, 47],
      [-24, 104],
      [-7, 88],
      [-31, 73],
      [28, 29],
      [-11, 118],
      [-25, 162],
      [-40, 154],
      [-67, 120],
      [-57, 79],
      [-77, 80],
      [-106, 91],
      [-82, 41],
    ],
    [
      [10285, 26672],
      [-76, -27],
      [-48, -57],
      [-51, -15],
      [-31, -44],
      [-78, 25],
      [-56, -29],
      [-40, 27],
      [-86, -49],
      [-72, 60],
      [-46, 0],
      [-135, 98],
      [-7, -124],
      [-34, -36],
      [3, -53],
      [-85, -126],
      [-57, 28],
      [-57, -40],
      [-38, 12],
      [-107, -36],
      [-63, -42],
      [-4, -53],
      [115, -18],
      [18, -68],
      [-67, -18],
      [-33, -112],
      [-93, -84],
      [93, -64],
      [10, -130],
      [84, 19],
      [1, -49],
      [64, -25],
      [-23, -56],
      [53, -61],
      [41, 2],
      [-21, -70],
      [-39, 13],
      [-12, -63],
      [-50, -67],
      [-140, -45],
      [-168, 3],
      [-61, -65],
      [40, -72],
      [-69, -19],
      [4, -49],
      [36, -69],
      [-7, -46],
      [-102, -21],
      [-71, 20],
      [-18, 90],
      [-117, 13],
      [-75, -35],
      [-38, -39],
      [-130, -19],
      [16, -73],
      [-42, -41],
      [-59, -19],
      [-111, -2],
      [-38, -144],
      [-37, -29],
      [-78, -136],
      [11, -57],
      [-10, -71],
      [-63, -57],
      [-1, -30],
      [-85, -2],
      [-43, 30],
      [-117, -2],
      [-44, -58],
      [-64, -24],
      [-33, 65],
      [-52, 35],
      [-80, 8],
      [37, 101],
      [33, 134],
      [-76, 37],
    ],
    [
      [6729, 26328],
      [29, 26],
      [31, 105],
      [-3, 67],
      [-70, 56],
      [-64, -12],
      [-35, 103],
      [48, 90],
      [-26, 31],
      [68, 50],
      [-28, 78],
      [38, 35],
      [52, 143],
      [39, -26],
      [84, 4],
      [26, -21],
      [80, 49],
      [101, 32],
      [45, -55],
      [109, -43],
      [9, -38],
      [-47, -44],
      [43, -24],
      [59, 13],
      [44, -42],
      [103, -28],
      [101, 18],
      [136, -21],
      [28, 12],
      [28, 67],
      [61, 54],
      [0, 89],
      [41, 65],
      [18, 100],
      [78, 18],
      [19, 79],
      [78, -2],
      [197, 63],
      [64, -2],
      [90, -56],
      [95, 57],
      [27, 45],
      [44, -2],
      [62, -57],
      [139, 67],
      [88, -48],
      [86, -5],
      [57, -48],
      [48, 31],
      [68, 6],
      [80, 29],
      [128, 83],
      [119, 39],
      [86, 5],
      [140, 60],
      [155, 28],
      [51, -47],
      [-47, -33],
      [-15, -57],
      [-105, -19],
      [-47, -43],
      [21, -106],
      [50, -63],
      [-6, -64],
      [52, -7],
      [44, -71],
      [47, 34],
      [49, -7],
      [61, -129],
      [-31, -42],
      [-6, -71],
      [113, -20],
      [27, -43],
      [33, -101],
      [104, -71],
      [65, -19],
    ],
    [
      [828, 23774],
      [-78, 31],
      [-6, 51],
      [-83, 26],
      [-26, 109],
      [-11, 153],
      [46, 66],
      [-77, 15],
      [-74, -5],
      [-34, 62],
      [-70, 13],
      [-75, 91],
      [-21, 92],
      [15, 158],
      [98, -7],
      [25, 31],
      [83, 25],
      [27, 29],
      [102, 54],
      [3, 55],
      [65, 50],
      [127, -152],
      [62, 48],
      [62, -47],
      [53, 70],
      [70, 1],
      [59, 79],
      [88, -20],
      [80, -41],
      [69, 43],
      [29, 38],
      [49, 7],
      [4, 40],
      [40, 27],
      [76, -14],
      [16, 66],
      [46, 7],
      [21, -33],
      [149, -5],
      [67, -56],
      [33, -52],
      [38, 37],
      [85, -48],
      [128, 15],
    ],
    [
      [10389, 22585],
      [-86, -60],
      [-8, -160],
      [-35, 23],
      [0, 18],
      [6, 23],
      [-2, 9],
      [-43, 21],
      [-15, 29],
      [7, 61],
      [55, 23],
      [121, 13],
    ],
    [
      [10345, 22637],
      [33, -51],
      [-66, -7],
      [33, 58],
    ],
    [
      [9952, 23218],
      [42, -120],
      [-96, 3],
      [7, 57],
      [44, 4],
      [3, 56],
    ],
    [
      [9862, 23636],
      [38, -9],
      [-15, -103],
      [-63, 9],
      [40, 103],
    ],
    [
      [11351, 24231],
      [20, -53],
      [-174, -16],
      [-158, -33],
      [-82, -68],
      [-107, -56],
      [-141, -88],
      [-118, -45],
      [-123, -68],
      [-186, -70],
      [-79, -55],
      [-20, 29],
      [45, 79],
      [39, 9],
      [33, 59],
      [37, -13],
      [3, -53],
      [111, 50],
      [43, 54],
      [48, -5],
      [14, 49],
      [-57, 9],
      [-111, 72],
      [-46, 6],
      [-61, -26],
      [-65, -90],
      [-81, -37],
      [-60, 4],
      [-33, -39],
      [-147, -73],
      [5, -108],
      [-76, 2],
      [-26, -63],
      [-46, -13],
      [37, -49],
      [-18, -34],
      [16, -52],
      [-84, -64],
      [13, -79],
      [30, -37],
      [82, 18],
      [14, -84],
      [-9, -74],
      [53, -28],
      [88, -12],
      [50, -22],
      [-9, -95],
      [-57, 19],
      [-53, -100],
      [31, -38],
      [124, 7],
      [21, -66],
      [35, -39],
      [-9, -61],
      [141, -31],
      [56, -79],
      [-60, -7],
      [-22, -18],
      [-24, 2],
      [10, -27],
      [-6, -38],
      [8, -28],
      [43, -24],
      [11, -14],
      [-6, -18],
      [1, -24],
      [6, -94],
      [-60, 19],
      [15, 102],
      [-72, -11],
      [-22, -56],
      [31, -35],
      [-22, -49],
      [21, -43],
      [-11, -49],
    ],
    [
      [10285, 26672],
      [71, -9],
      [71, -45],
      [148, -8],
      [41, 13],
      [82, -22],
      [41, -35],
    ],
  ],
  transform: {
    scale: [0.0005685370729853482, 0.0004192731819430088],
    translate: [6.630878925323543, 35.49763870239269],
  },
  objects: {
    ITA_adm1: {
      type: "GeometryCollection",
      geometries: [
        {
          arcs: [[0, 1, 2, 3]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 1,
            NAME_1: "Abruzzo",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Abruzos|Abruzzen|Abruzzes|Abruzzi",
          },
        },
        {
          arcs: [[4, 5, 6, 7]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 2,
            NAME_1: "Apulia",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Apulien|Pouilles|Pouille|Puglia|Puglie",
          },
        },
        {
          arcs: [[8, 9, 10, 11, -5]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 3,
            NAME_1: "Basilicata",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Basilicate|Lucania",
          },
        },
        {
          arcs: [[12, -10]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 4,
            NAME_1: "Calabria",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Calabre|Calabrie|Kalabrien",
          },
        },
        {
          arcs: [[[13]], [[14]], [[-6, -12, 15, 16, 17]]],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 5,
            NAME_1: "Campania",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Campanha|Campanie|Kampanien",
          },
        },
        {
          arcs: [[20, 21, 22, 23, 24, 25, 26, 27, 28]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 6,
            NAME_1: "Emilia-Romagna",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Emilia Romagna|Emilia|Emilia-Romaña|Émilie-Romagne",
          },
        },
        {
          arcs: [[[29]], [[30, 31]]],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 7,
            NAME_1: "Friuli-Venezia Giulia",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Autonomous Region",
            VARNAME_1: "Friuli Venezia Giulia|Friuli-Venecia Julia",
          },
        },
        {
          arcs: [[[32]], [[33, 34, -3, 35, -17, 36, 37]]],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 8,
            NAME_1: "Lazio",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Lacio|Latium",
          },
        },
        {
          arcs: [[-27, 38, 39, 40]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 9,
            NAME_1: "Liguria",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Ligurie|Ligurien",
          },
        },
        {
          arcs: [[41, 42, -29, 43, 44]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 10,
            NAME_1: "Lombardia",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Lombardy|Lombardei|Lombardie",
          },
        },
        {
          arcs: [[-4, -35, 45, 46, -25, 47, -19, 48, -23, 49], [50]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 11,
            NAME_1: "Marche",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Marches|Marca",
          },
        },
        {
          arcs: [[-7, -18, -36, -2, 51]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 12,
            NAME_1: "Molise",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Molisa",
          },
        },
        {
          arcs: [[-44, -28, -41, 52, 53, 54]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 13,
            NAME_1: "Piemonte",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Piemont|Piémont|Piemonte|Piedmont",
          },
        },
        {
          arcs: [[[55]], [[56]], [[57]], [[58]], [[59]], [[60]]],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 14,
            NAME_1: "Sardegna",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Autonomous Region",
            VARNAME_1: "Cerdeña|Sardenha",
          },
        },
        {
          arcs: [
            [[61]],
            [[62]],
            [[63]],
            [[64]],
            [[65]],
            [[66]],
            [[67]],
            [[68]],
            [[69]],
            [[70]],
            [[71]],
          ],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 15,
            NAME_1: "Sicily",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Autonomous Region",
            VARNAME_1: "Sicilia",
          },
        },
        {
          arcs: [[[72]], [[73]], [[74]], [[75]], [[-51]], [[-47, 76, -38, 77, -39, -26]]],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 16,
            NAME_1: "Toscana",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Tuscany|Toscane|Toskana",
          },
        },
        {
          arcs: [[78, -42, 79]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 17,
            NAME_1: "Trentino-Alto Adige",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Autonomous Region",
            VARNAME_1:
              "Trentino - Alto Adige|Trentino-Alto Adigio|Trentino-South Tirol|Venezia Tridentina",
          },
        },
        {
          arcs: [[-34, -77, -46]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 18,
            NAME_1: "Umbria",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Ombrie|Umbrien",
          },
        },
        {
          arcs: [[-54, 80]],
          type: "Polygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 19,
            NAME_1: "Valle d'Aosta",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Autonomous Region",
            VARNAME_1: "Aosta Valley|Val d'Aoste|Vallée d'Aoste",
          },
        },
        {
          arcs: [[[81]], [[82]], [[83]], [[84]], [[-31, 85, -21, -43, -79, 86]]],
          type: "MultiPolygon",
          properties: {
            ISO: "ITA",
            NAME_0: "Italy",
            ID_1: 20,
            NAME_1: "Veneto",
            HASC_1: "",
            TYPE_1: "Regione",
            ENGTYPE_1: "Region",
            VARNAME_1: "Venecia|Venetia|Venezia Euganea",
          },
        },
      ],
    },
  },
} satisfies Topology;
